import { handleActions } from 'redux-actions';
import {
  requestTiers,
  requestTiersFailure,
  requestTiersSuccess,
} from './actions';
import { TierListStoreSlice } from './types';

const reducers = handleActions<TierListStoreSlice, any>(
  {
    [requestTiers.toString()]: state => ({
      ...state,
      requestStatus: 'fetching',
    }),
    [requestTiersSuccess.toString()]: (
      state,
      action: ReturnType<typeof requestTiersSuccess>
    ) => ({
      ...state,
      requestStatus: 'idle',
      tiers: action.payload.tiers,
    }),
    [requestTiersFailure.toString()]: (
      state,
      action: ReturnType<typeof requestTiersFailure>
    ) => ({
      ...state,
      requestStatus: 'error',
      errorMessage: action.payload.error,
    }),
  },
  {
    tiers: [],
    requestStatus: 'idle',
  }
);
export default reducers;
